<template>
  <div class="container section">
    <div class="row heading">
      <div class="col-6">
        <h2>Agent Info</h2>
      </div>
      <div class="col-6 text-right" v-if="this.$store.getters.getUserRoles[15]">

        <router-link
                :to="'/account-details?general_search=&account_status=%5B%5D&account_mrc=%5Bnull,null%5D&latest_comms=%5Bnull,null%5D&ink_date=%7B%22timeframe%22%3A%22%22,%22start%22%3A%22%22,%22end%22%3A%22%22,%22group%22%3A%22%22%7D&term_date=%7B%22timeframe%22%3A%22%22,%22start%22%3A%22%22,%22end%22%3A%22%22,%22group%22%3A%22%22%7D&subagents=%5B%22' + encodeURI(agentProfile.name) + '%22%5D&approved=%5B%5D&estimated_comms=%5Bnull,null%5D&term=%5Bnull,null%5D&expected_spiff=%5Bnull,null%5D&actual_spiff=%5Bnull,null%5D&actual_delta=%5Bnull,null%5D&off_expected=%5Bnull,null%5D&spiff_delta=%5Bnull,null%5D&telno=&telno_carriers=&name=&carrier_name=&telno_carrier=&columns=%5B%22ink_date%22,%22term%22,%22name%22,%22carrier_name%22,%22subagents%22%5D&sort=%5B%7B%22field%22%3A%22ink_date%22,%22dir%22%3A%22DESC%22%7D%5D&page=1&limit=25'"
                   class="btn btn-light btn-sm"><i class="fa fa-external-link-square"></i>&nbsp;&nbsp;View Co-sold Accounts</router-link>

        <button v-if="editing != 'info'" @click="editInfo" class="btn btn-primary btn-sm"><i class="fa fa-gear"></i>&nbsp;&nbsp;Edit</button>
            <span v-if="editing == 'info'">
              <button @click="saveInfo" class="btn btn-success btn-sm"><i class="fa fa-check"></i>&nbsp;&nbsp;Save</button>
              <button @click="editing = null" class="btn btn-clear btn-sm">Cancel</button>
            </span>
      </div>
    </div>
    <div class="row">
      <label class="col-xs-6 col-sm-2 col-form-label">Name</label>
      <div class="col-xs-6 col-sm-4">
            <span v-if="editing != 'info'">
              {{agentProfile.name || '-'}}
            </span>

        <input v-if="editing == 'info'" v-model="selected.name" class="form-control" />

      </div>
      <label class="col-xs-12 col-sm-2 col-form-label">Email</label>
      <div class="col-xs-12 col-sm-4">
            <span v-if="editing != 'info'">
              {{agentProfile.email || '-'}}
            </span>
        <input v-if="editing == 'info'" v-model="selected.email" class="form-control" />
      </div>
    </div>

    <div class="row">
      <label class="col-xs-12 col-sm-2 col-form-label">Username</label>
      <div class="col-xs-12 col-sm-4">
          <span v-if="editing != 'info'">
              {{agentProfile.username || '-'}}
            </span>
        <input v-if="editing == 'info'" v-model="selected.username" class="form-control" />
      </div>
      <label class="col-xs-12 col-sm-2 col-form-label">Password</label>
      <div class="col-xs-12 col-sm-4" >
        <span v-show="editing != 'info'">******</span>
        <span ><input style="margin-bottom:5px;" v-show="editing == 'info'" type="password" v-model="selected.new_password" class="form-control" placeholder="Enter new password" /></span>
        <span><input v-show="editing == 'info'" type="password" v-model="selected.new_password_confirm" class="form-control" placeholder="Repeat new password" /></span>
      </div>
    </div>
    <div class="row">
      <label class="col-xs-12 col-sm-2 col-form-label">Telno</label>
      <div class="col-xs-12 col-sm-4">
          <span v-if="editing != 'info'">
              {{ agentProfile.telno || '-'}}
            </span>
        <input v-if="editing == 'info'" v-model="selected.telno" class="form-control" />
      </div>
      <label class="col-xs-12 col-sm-2 col-form-label">Status</label>
      <div class="col-xs-12 col-sm-4">
          <span v-if="editing != 'info'">
              {{ agentProfile.status | displayStatus}}
            </span>
        <dropdown v-if="editing == 'info'" :list="statuses" :value="selected.status | displayStatus"  @change="setStatus" @input="setStatus" ></dropdown>
      </div>
    </div>



    <div class="row" v-if="!agentProfile.is_channel">
      <label class="col-xs-12 col-sm-2 col-form-label">Channel</label>
      <div class="col-xs-12 col-sm-4">
         <span v-if="editing != 'info'">
            {{ agentProfile.channel_name || '-' }}
           </span>
        <autocomplete v-if="editing == 'info'" :list="channelNames" :selection="selected.channel_name" @input="fetchChannels" @change="setChannel" ></autocomplete>
      </div>

      <label class="col-xs-12 col-sm-2 col-form-label">Referrer</label>
      <div class="col-xs-12 col-sm-8 col-md-4 col-lg-3">
         <span v-if="editing != 'info'">
            {{ agentProfile.referrer_name || '-' }}
           </span>
        <autocomplete v-if="editing == 'info'" :list="referrerNames" :selection="selected.referrer_name" @input="fetchAgents" @change="setReferrer" ></autocomplete>
      </div>

    </div>


    <div class="row" v-if="!agentProfile.is_channel">
      <label class="col-xs-12 col-sm-2 col-form-label">Company</label>
      <div class="col-xs-12 col-sm-4">
         <span v-if="editing != 'info'">
            {{ agentProfile.company_name || '-' }}
           </span>
        <input v-if="editing == 'info'" v-model="selected.company_name" class="form-control" />
      </div>



    </div>

    <hr />
    <div>
      <div class="row" >
        <label class="col-xs-12 col-sm-2 col-form-label">Sandler ID</label>
        <div class="col-xs-12 col-sm-4">
        <span v-if="editing != 'info'">
            {{agentProfile.sandler_id || '-'}}
          </span>
          <input v-if="editing == 'info'" v-model="selected.sandler_id" class="form-control" />
        </div>
      </div>

      <div class="row">
        <label class="col-xs-12 col-sm-2 col-form-label">Username</label>
        <div class="col-xs-12 col-sm-4">
          <span v-if="editing != 'info'">
            {{agentProfile.sandler_username || '-'}}
          </span>
          <input v-if="editing == 'info'" v-model="selected.sandler_username" class="form-control" />

        </div>
        <label class="col-xs-12 col-sm-2 col-form-label">Password</label>
        <div class="col-xs-12 col-sm-4" >
          <span v-show="editing != 'info' && !showPass">****** &nbsp;&nbsp;&nbsp;
            <button class="btn btn-sm btn-light" @click="showPass=true">Show</button>
          </span>
          <span v-show="editing != 'info' && showPass">{{agentProfile.sandler_password}} &nbsp;&nbsp;&nbsp;<button class="btn btn-sm btn-light" @click="showPass=false">Hide</button></span>
          <span>
            <input style="margin-bottom:5px;" v-show="editing == 'info'" v-model="selected.sandler_password" class="form-control" placeholder="Enter new password" />
          </span>
        </div>


        </div>
    </div>
    <hr />
    <div>
      <div class="row" >
        <label class="col-xs-12 col-sm-2 col-form-label">Tags</label>
        <div class="col-xs-12 col-sm-10">
          <div class="tag-search">
            <autocomplete  placeholder="Enter a Tag" :list="tagNames" :selection="tag" @input="searchTags" @change="createTag" @enter="createTag" loose allowNew></autocomplete>
          </div>
        <div class="tag" v-for="t in agentTags" :key="t.userTag_id">
          {{t.name}} <i class="fa fa-remove" @click="removeTag(t.userTag_id);" />
        </div>

        </div>

      </div>
      </div>
  </div>


</template>
<script type="text/babel">
  import Modal from '../assets/Modal.vue';
  import draggable from 'vuedraggable';
  import Dropdown from '../assets/Dropdown.vue';
  import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
  import Autocomplete from '../assets/Autocomplete.vue';

  export default {
    name: 'AgentInfo',
    data: function(){
      return {
        showPass:false,
        selectedOverrideAgent:{},
        selectedCarrier: {},
        showAddOverride: false,
        active: 'default',
        editing: '',
        agentProfile:{
          username: null,
          name: null,
          Abcomm: null,
          telno:null,
          sandler_username:null,
          sandler_password:null,
          sandler_id:null,
          email: null,
          channel_id: null,
          channel_name: null,
          company_name: null,
          referrer_id: null,
          referrer_name: null,
          is_channel: false,
        },
        agentTags: [],
        agents:[],
        carriers:[],
        channels:[],
        channel: '',
        statuses:[
          'Active',
          'Inactive'
        ],
        selected:{},
        draggableOptions:{
          handle: ".drag-handle",
          animation: 150
        },
        tagList: [],
        tag: ''
      }
    },
    components:{
      Dropdown,
      DropdownConfirmation,
      Autocomplete,
      draggable,
      Modal
    },
    computed:{

      channelNames(){
        return this.channels.map(function(u){
          return u.name;
        })
      },
      referrerNames(){
        return this.agents.map(function(u){
          return u.name;
        })
      },
      tagNames(){
        return this.tagList.map(t => t.name);
      }


    },
    created(){
      this.fetchProfile();
      this.fetchTags();
    },
    filters:{
      displayStatus(status){
        return (status == "1")? 'Active' : 'Inactive';
      }

    },
    methods:{
      searchTags(t){
        if(!t) return;
        this.tag = t;
        this.$send(this, 'tags', {
          tag: t
        }).then(r => {
          console.log(r);
          this.tagList = r.tags || [];
        });
      },
      fetchTags(){

        this.$send(this, 'userTags', {
          user_id: this.$route.params.agent_id
        }).then(r => {
          this.agentTags = r.userTags;
        });
      },
      createTag(t){

        if(!t) return;
        this.$send(this, 'userTagCreate', {
          user_id: this.$route.params.agent_id,
          tag: t
        }).then(r => {
          this.tag = '';
          this.fetchTags();
        });
      },
      removeTag(userTag_id){
        if(!userTag_id) return;
        this.$send(this, 'userTagDelete', {
          user_id: this.$route.params.agent_id,
          userTag_id: userTag_id
        }).then(r => {
          this.fetchTags();
        });
      },
      setStatus(status){
        this.selected.status = (status == 'Active') ? 1: 0;
      },
      saveInfo(){

        var data = this.selected;

        data.user_id = this.$route.params.agent_id;

        this.$send(this, 'userProfileUpdate',data).then(r => {
          this.fetchProfile();
          this.editing = null;
        });
      },

      setChannel(selection){

        if(!selection){
          this.selected.channel_id = '';
          this.selected.channel_name = '';
          return;
        }

        var selectedChannel = this.channels.filter(function(c){
            return c.name == selection;
        })[0];

        if(selectedChannel.channel_id){
          this.selected.channel_id = selectedChannel.channel_id;
          this.selected.channel_name = selectedChannel.name;
        } else {
          this.selected.channel_id = '';
          this.selected.channel_name = '';
        }



      },
      setReferrer(selection){

        if(!selection){
          this.selected.referrer_id = '';
          this.selected.referrer_name = '';
          return;
        }

        var selectedReferrer = this.agents.filter(function(c){
          return c.name == selection;
        })[0];

        if(selectedReferrer.user_id){
          this.selected.referrer_id = selectedReferrer.user_id;
          this.selected.referrer_name = selectedReferrer.name;
        } else {
          this.selected.referrer_id = '';
          this.selected.referrer_name = '';
        }



      },
      editInfo(){
        this.editing = 'info';
        this.selected = JSON.parse(JSON.stringify(this.agentProfile));
        this.selected.new_password = "";
        this.selected.new_password_confirm = "";
        this.selected.sandler_password = "";
      },
      fetchProfile(){
        this.$send(this, 'userProfile',{
          user_id: this.$route.params.agent_id
        }).then(r => {
          this.agentProfile = r.userProfile;
        });
      },
      fetchChannels(search){
        var _this = this;

        this.selected.channel_name = search;
        this.$send(this, 'channels',{
          search: search
        }).then(r => {
          this.channels = r.channels;
        });
      },
      fetchAgents(search){
        this.selected.referrer_name = search;
        this.$send(this, 'userUsers',{
          search: search
        }).then(r => {
          this.agents = r.userUsers;
        });
      },
      isActive(label){
        return this.active == label;
      }
    },
    mounted(){

    },
    props:[]
  }
</script>

<style>
  .row{
    position: relative;
  }
  .commission-section {
    padding: 10px 15px;
    border: 1px solid #e2e2e2;
  }
  .commission-section.active {
    background: #f0f7fc;
    border: 1px solid #aabcca;
  }

  .commission-section .section-header{
    cursor: pointer;
  }


  .commission-section .section-header i{
    -webkit-transition: .25s ease-in-out;
    -moz-transition: .25s ease-in-out;
    -o-transition: .25s ease-in-out;
  }
  .commission-section.active .section-header i{
    -ms-transform: rotate(90deg); /* IE 9 */
    -webkit-transform: rotate(90deg); /* Chrome, Safari, Opera */
    transform: rotate(90deg);
  }
  .commission-section.active .section-header{
    /*  border-bottom: 1px solid #aabcca; */
    margin-bottom: 20px;
  }
  /*
    .commission-section.active .section-header {
      border: 1px solid white;
      margin-bottom: 20px;
      background: #325482;
      color: white;
    }
    */
  .commission-section .container{
    display: none;
    width: 100%;
  }
  .commission-section.active .container{
    display: block;
  }
  .row>.col.col-form-label,
  .row>[class^=col-].col-form-label{
    padding-top: 10px;
  }


  .drag-handle.col-form-label {
    width: 10px;
    color: #cccccc;
    padding: 15px 10px 15px 0;
    cursor: move;
    margin-right: 15px;
    position: absolute;
    left: -11px;
    top: 50%;
    height: 35px;
    margin-top: -18px;
  }
  .drag-handle i {
    margin: 0;
    padding: 0;
    font-size: 8px;
    line-height: 8px;
    margin-bottom: -15px;
    display: block;
  }
  .dragrow{
    background: white;
  }
  .sortable-ghost.sortable-chosen{
    background: #ccc;
    opacity:.25;
  }
  .sortable-drag{
    border: 1px solid #ccc;

    overflow: visible;
  }

  svg.svgIcon {
    width: 16px;
    height: 16px;
    color: #ccc;
  }

  .dropdown.confirmation {
    display: inline-block;
  }
  .dropdown.confirmation > .dropdown-menu {
    padding: 20px;
    font-size: 12px;
    width: 250px;
  }
  .confirmation-footer {
    margin-top: 30px;
    text-align: right;
  }

  .tag{
    background-color: #dfebf6;
    border: 1px solid #5e9cd3;
    border-radius: 2px;
    padding: 3px 5px;
    display: inline-block;
    margin: 3px;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */

  }

  .tag i{
    color: #5e9cd3;

  }

  .tag-search{
    width: 200px;
    margin-bottom:10px;;
  }


</style>



// WEBPACK FOOTER //
// AgentInfo.vue?17405240